import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchPpeComponentList = (data) => {
  return axios.get(`${apiurl?.getPpeComponentList}/${data?.id}?searchCriteria=${data?.searchCriteria}`);
};

const getPpeComponentList = (data) => {
  return useQuery(['getPpeComponentList', data], () => fetchPpeComponentList(data), { refetchOnWindowFocus: false });
};

export default getPpeComponentList;
